import { makeStyles } from '@material-ui/core';

import { ProductsTable } from '../Tables/ProductsTable.component';
import { OrderItem } from '../../types/order-item.type';
import { computeTotalsLocal, GlobalDiscount } from '../../../quotes/utils/compute-totals-local.util';

type Props = {
  items: OrderItem[];
  onIncrease: (id: string) => void;
  onDecrease: (id: string) => void;
  onChangeQuantity: (id: string, value: string) => void;
  companyDiscountPercent?: number;
  globalDiscount?: GlobalDiscount;
  deliveryCost?: number;
};

const useStyles = makeStyles({
  orderSummary: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',

    '& > h4': {
      margin: 0,
      opacity: 0.7,
    },
  },
  totals: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '1.5rem',

    '& > p': {
      margin: 0,
    },
  },
});

export function OrderSummaryContainer({
  items,
  onIncrease,
  onDecrease,
  onChangeQuantity,
  companyDiscountPercent,
  globalDiscount,
  deliveryCost,
}: Props) {
  const classes = useStyles();

  const shouldDisplayTotals =
    companyDiscountPercent !== undefined || globalDiscount !== undefined || deliveryCost !== undefined;
  const totals = shouldDisplayTotals
    ? computeTotalsLocal({
        items: items.map((item) => ({ price: item.price, quantity: item.quantity, tvaRate: item.tvaRate })),
        companyDiscountPercent,
        globalDiscount,
        deliveryCost,
      })
    : null;

  return (
    <div className={classes.orderSummary}>
      <h4>Récapitulatif</h4>
      <ProductsTable
        items={items}
        onIncrease={onIncrease}
        onDecrease={onDecrease}
        onChangeQuantity={onChangeQuantity}
      />
      {totals && (
        <div className={classes.totals}>
          {totals.totalDiscount > 0 && <p>Remise : −{totals.totalDiscount.toFixed(2)} €</p>}
          <p>Frais de livraison : {totals.deliveryCost.toFixed(2)} €</p>
          <p>Total HT : {totals.totalHt.toFixed(2)} €</p>
          <p>
            <strong>Total TTC : {totals.totalTtc.toFixed(2)} €</strong>
          </p>
        </div>
      )}
    </div>
  );
}
